"use client";

import { Input } from "@/components/ui/input";
import { useFormContext } from "react-hook-form";
import { useFormField } from "@/components/ui/form";

export const FormInput = (props: React.ComponentProps<typeof Input>) => {
  const { register } = useFormContext();
  const { name, rules } = useFormField();
  return <Input {...props} {...register(name, rules)} />;
};
